export default "__VITE_ASSET__6a31130d__"